import { render, staticRenderFns } from "./cus-package.vue?vue&type=template&id=296ab389&scoped=true"
import script from "./cus-package.vue?vue&type=script&lang=ts"
export * from "./cus-package.vue?vue&type=script&lang=ts"
import style0 from "./cus-package.vue?vue&type=style&index=0&id=296ab389&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296ab389",
  null
  
)

export default component.exports